import WildAppResource from "./WildAppResource";

export const AL = 11010; // Alabama
export const AK = 11011; // Alaska
export const AZ = 11012; // Arizona
export const AR = 11013; // Arkansas
export const CA = 11014; // California
export const CO = 11015; // Colorado
export const CT = 11016; // Connecticut
export const DE = 11017; // Delaware
export const FL = 11018; // Florida
export const GA = 11019; // Georgia
export const HI = 11020; // Hawaii
export const ID = 11021; // Idaho
export const IL = 11022; // Illinois
export const IN = 11023; // Indiana
export const IA = 11024; // Iowa
export const KS = 11025; // Kansas
export const KY = 11026; // Kentucky
export const LA = 11027; // Louisiana
export const ME = 11028; // Maine
export const MD = 11029; // Maryland
export const MA = 11030; // Massachusetts
export const MI = 11031; // Michigan
export const MN = 11032; // Minnesota
export const MS = 11033; // Mississippi
export const MO = 11034; // Missouri
export const MT = 11035; // Montana
export const NE = 11036; // Nebraska
export const NV = 11037; // Nevada
export const NH = 11038; // New Hampshire
export const NJ = 11039; // New Jersey
export const NM = 11040; // New Mexico
export const NY = 11041; // New York
export const NC = 11042; // North Carolina
export const ND = 11043; // North Dakota
export const OH = 11044; // Ohio
export const OK = 11045; // Oklahoma
export const OR = 11046; // Oregon
export const PA = 11047; // Pennsylvania
export const RI = 11048; // Rhode Island
export const SC = 11049; // South Carolina
export const SD = 11050; // South Dakota
export const TN = 11051; // Tennessee
export const TX = 11052; // Texas
export const UT = 11053; // Utah
export const VT = 11054; // Vermont
export const VA = 11055; // Virginia
export const WA = 11056; // Washington
export const WV = 11057; // West Virginia
export const WI = 11058; // Wisconsin
export const WY = 11059; // Wyoming

export const ALL = {
    AL,// Alabama
    AK, // Alaska
    AZ, // Arizona
    AR,// Arkansas
    CA, // California
    CO, // Colorado
    CT, // Connecticut
    DE, // Delaware
    FL, // Florida
    GA, // Georgia
    HI,// Hawaii
    ID,// Idaho
    IL,// Illinois
    IN, // Indiana
    IA, // Iowa
    KS, // Kansas
    KY,// Kentucky
    LA, // Louisiana
    ME,// Maine
    MD, // Maryland
    MA, // Massachusetts
    MI, // Michigan
    MN, // Minnesota
    MS, // Mississippi
    MO,// Missouri
    MT,// Montana
    NE, // Nebraska
    NV, // Nevada
    NH, // New Hampshire
    NJ, // New Jersey
    NM,// New Mexico
    NY, // New York
    NC, // North Carolina
    ND,// North Dakota
    OH,// Ohio
    OK, // Oklahoma
    OR, // Oregon
    PA, // Pennsylvania
    RI, // Rhode Island
    SC,// South Carolina
    SD,// South Dakota
    TN,// Tennessee
    TX, // Texas
    UT, // Utah
    VT, // Vermont
    VA, // Virginia
    WA, // Washington
    WV, // West Virginia
    WI, // Wisconsin
    WY, // Wyoming
};

class LuStateAppResource extends WildAppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'lu-state';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'lus/states';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'slug',
            'title',
            'description',
            'isEnabled',
            'meta',
            'uuid',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {};
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {};
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            slug: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
        };
    }
}

export default LuStateAppResource;
